export const environment = {
    production: false,
    // baseUrl: 'https://api.passbookapp.in/',
    baseUrl: 'https://dev-api.passbookapp.in/',
    // baseUrl: 'https://api.passbookapp.in/',
    // baseUrl: 'https://stage-api.passbookapp.in/',


    sasToken:
        '?sv=2024-11-04&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2030-05-10T01:10:57Z&st=2025-06-13T17:10:57Z&spr=https,http&sig=S13EFXN4J4DYC7iBfkXNEu3eyvcHFtjj1aV46G667WA%3D',
    accountName: 'passbookapp',
    containerName: 'dev-lagubandhu',
    imageUploadSize: 1000000,
    firebaseConfig: {
        apiKey: "AIzaSyCjQuQN1TwWv0DMmMTIY6VRgSv_WplLR9A",
        authDomain: "finshakti-ssp.firebaseapp.com",
        projectId: "finshakti-ssp",
        storageBucket: "finshakti-ssp.appspot.com",
        messagingSenderId: "710088896028",
        appId: "1:710088896028:web:e4228284f0642e2ee1f9d9",
        measurementId: "G-3XBV4ENER3"
    },

    domainEndPoint: ".dev.passbookapp.in",
    erpEndPoint: ".devssp.passbookapp.in",
    primaryColor: '#000',
    logoImage: '',
    companyName: '',
    bannerImage: '',
    bId: '',
}